import {Component, inject, signal} from '@angular/core'
import {MatDialog, MatDialogActions, MatDialogClose, MatDialogTitle} from '@angular/material/dialog'
import {MatFormField, MatInput, MatLabel} from '@angular/material/input'
import {FormsModule} from '@angular/forms'
import {MatButton} from '@angular/material/button'
import {DataService} from '../../../services/data.service'
import {IWaitComponentData, WaitComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {ILoan} from '@sparbanken-syd/loan-renewal-be'
import {LoanDisplayComponent} from '../loan-display/loan-display.component'

@Component({
  selector: 'spb-select',
  imports: [
    MatDialogTitle,
    MatFormField,
    MatLabel,
    FormsModule,
    MatButton,
    MatInput,
    LoanDisplayComponent,
    MatDialogActions,
    MatDialogClose
  ],
  templateUrl: './select.component.html'
})
export class SelectComponent {
  public loanNumber = signal<string>('')

  public loan = signal<ILoan | null>(null)

  private dataService = inject(DataService)

  private dialog = inject(MatDialog)

  public getLoan() {
    this.loan.set(null)
    const ref = this.dialog.open<WaitComponent, IWaitComponentData, void>(
      WaitComponent, {
        data: {
          title: 'Hämtar lån...',
          progress: true
        }
      }
    )
    this.dataService.getLoanDetails(this.loanNumber())
      .subscribe(
        data => {
          ref.close()
          if (data) {
            this.loan.set(data)
          } else {
            this.dialog.open(WaitComponent, {
              data: {
                title: 'Lånet finns inte',
                text: 'Kan inte hitta lånet, kontrollera och försök igen.',
                closable: true
              }
            })
          }
        }
      )
  }
}
